module.exports = __webpack_public_path__ + "img/logo.c44aa653.svg";